import React, { Component } from 'react';
import { Redirect, withRouter } from 'react-router-dom'; // <-- use Redirect
import CanvaEditor from './CanvaEditor';
import Alerts from '../../components/alert/Alert';
import { Button, Col, Modal, Row } from 'antd';
import { CanvaColorsContainer, CanvaColorsSection, CanvaColorsSubtitle, CanvaFiltersSection } from './CanvaStyles';
import { ApproveFinalWeddingCanva, AutoSelectCanvaOptions, GetWeddingCanvaColors, GetWeddingCanvaOptions, GetWeddingCanvas, RenderWeddingCanva, SaveWeddingCanvaColors, SubmitFinalWeddingCanva, UpdateWeddingCanva, ValidateWeddingCanvaSubmission } from '../../infra/requests/WeddingCanvaRequests';
import { ImageOptionPanel } from '../../components/inputs/ImageOptionPanel';
import SelectInput from '../inputs/SelectInput';
import BaseButton from '../buttons/BaseButton';
import XpertGoLeavePageBlocker from '../pageBlocker/XpertGoLeavePageBlocker';
import { SectionTitle } from '../../styles/BasicStyles';
import { WeddingCanvaColorCard } from '../../components/optionCard/WeddingCanvaColorCard';
import { withLocalize } from 'react-localize-redux';
import { GetWeddingCanvaConfigs } from '../../infra/requests/WeddingCanvaConfigsRequests';

class CanvaEditorPage extends Component {
    state = {
        loading: true,
        redirect: false,

        selectedWeddingCanva: null,

        canvaMenu: [],
        sectionsList: [],
        chaptersList: [],
        questionsList: [],
        optionsList: [],

        selectedSection: null,
        selectedSectionObj: null,
        selectedChapter: null,
        selectedChapterObj: null,
        selectedQuestion: null,
        selectedQuestionObj: null,
        selectedOption: null,
        selectedOptionObj: null,

        canvaImage: [],

        optionModalVisible: false,
        drawerVisible: false,
        panelCollapsed: false,

        loadingColors: false,
        colorsLoaded: false,
        showColors: false,
        colorsAnswerId: null,
        colorsChapter: null,
        colors: [],
        answeredColors: [],
        colorsQuestion: null,

        hasCanvaChanges: false,
        instructionsModalVisible: false,
        warningOptionIds: [],
        warningColor: null,

        paletteModalVisible: false,
        tempAnsweredColors: []
    };

    canvaEditorRef = React.createRef();

    async componentDidMount() {
        this.getWeddingCanvaConfigs();
        this.getWeddingCanva();
    }

    getWeddingCanvaConfigs = async () => {
        const res = await GetWeddingCanvaConfigs();
        if (res?.success) {
            const configs = res?.data ? res?.data : null;
            if (configs && configs?.blockCanvaForCouple) {
                this.props.history.push('/404');
            }
        }
    }

    getWeddingCanva = async () => {
        const { location, match, translate } = this.props;
        const canvaId = location.state?.canvaId;
        const weddingId = match.params.wedding;

        if (!canvaId) {
            this.setState({ redirect: true });
            return;
        }

        const weddingCanvaRes = await RenderWeddingCanva(canvaId);
        if (!weddingCanvaRes?.success) {
            return Alerts.new({
                type: 'error',
                title: translate("ERROR"),
                text: translate("ERROR_ON_CANVA_SAVE")
            });
        }

        const selectedWeddingCanva = weddingCanvaRes?.data?.weddingCanva;
        const canvaMenu = weddingCanvaRes?.data?.options || [];
        const sectionsList = canvaMenu.map(c => ({
            _id: c.section._id,
            name: c.section.tag
        }));

        this.setState({
            selectedWeddingCanva,
            canvaMenu,
            sectionsList,
            loading: false
        });
    }

    handleSectionChange = value => {
        const { location, match, activeLanguage } = this.props;
        const weddingId = match.params.wedding;

        const selectedSectionObj = this.state.canvaMenu.find(
            c => String(c.section._id) === value
        );

        const chaptersList = selectedSectionObj?.chapters.map(c => ({
            _id: c.chapter._id,
            name: c.chapter.name[activeLanguage?.code]
        }));

        this.setState({
            selectedSection: value,
            selectedSectionObj,
            chaptersList,
            selectedChapter: null,
            questionsList: [],
            selectedQuestion: null,
            optionsList: [],
            selectedOption: null
        });

        const sectionTag = selectedSectionObj?.section?.tag;
        if (sectionTag === 'DECORATION' || sectionTag === 'CEREMONY') {
            this.getWeddingColors(weddingId, selectedSectionObj?.section?.tag);
        }
    };

    handleChapterChange = value => {
        const { activeLanguage } = this.props;

        const selectedChapterObj = this.state.selectedSectionObj.chapters.find(
            c => String(c.chapter._id) === value
        );

        const questionsList = selectedChapterObj.questions.map(c => ({
            _id: c.question._id,
            name: c.question.title[activeLanguage?.code]
        }));

        this.setState({
            selectedChapter: value,
            selectedChapterObj,
            questionsList,
            selectedQuestion: null,
            optionsList: [],
            selectedOption: null
        });
    };

    handleQuestionChange = value => {
        const { activeLanguage } = this.props;

        const selectedQuestionObj = this.state.selectedChapterObj.questions.find(
            c => String(c.question._id) === value
        );

        const optionsList = selectedQuestionObj.options.map(o => {
            const file = o?.canvaImages?.[0]?.file;
            return {
                _id: o._id,
                name: o.title[activeLanguage?.code],
                cost: o.cost,
                image: file
                    ? `${process.env.REACT_APP_API}/files/${file._id}`
                    : null
            };
        });

        this.setState({
            selectedQuestion: value,
            selectedQuestionObj,
            optionsList,
            optionModalVisible: true,
            selectedOption: null
        });
    };

    handleOptionChange = ({ optionId, quantity }) => {
        const selectedOptionObj = this.state.selectedQuestionObj.options.find(
            o => String(o._id) === optionId
        );

        const image = selectedOptionObj?.canvaImages?.[0];
        const file = image?.file;
        const canvaImages = [];

        if (file) {
            for (let i = 0; i < quantity; i++) {
                canvaImages.push({
                    id: `${file?._id}_${i}`,
                    url: `${process.env.REACT_APP_API}/files/${file?._id}`,
                    imageId: image?._id,
                    optionId: selectedOptionObj?._id,
                    date: new Date().toISOString()
                });
            }
        }

        this.setState({
            selectedOption: optionId,
            selectedOptionObj,
            canvaImage: canvaImages
        });

        this.setState({
            optionModalVisible: false,
            selectedSection: null,
            chaptersList: [],
            selectedChapter: null,
            questionsList: [],
            selectedQuestion: null,
            optionsList: [],
            selectedOption: null
        });
    };

    getWeddingColors = async (weddingId, section) => {
        this.setState({ loadingColors: true });

        try {
            const colorsRes = await GetWeddingCanvaColors(weddingId, section);

            if (colorsRes?.success) {
                const colorsData = colorsRes?.data;

                this.setState({
                    colorsLoaded: true,
                    showColors: true,
                    colorsAnswerId: colorsData?._id,
                    colorsChapter: colorsData?.question?.chapter,
                    colors: colorsData?.options || [],
                    answeredColors: colorsData?.response || [],
                    colorsQuestion: colorsData?.question
                });
            } else {
                this.setState({
                    colorsLoaded: false,
                    showColors: false,
                    colorsAnswerId: null,
                    colorsChapter: null,
                    colors: [],
                    answeredColors: [],
                    colorsQuestion: null
                });
            }
        } finally {
            this.setState({ loadingColors: false });
        }
    }

    saveCanvaEditor = async (canva) => {
        const { history, match, translate } = this.props;
        const { selectedWeddingCanva } = this.state;
        const weddingId = match?.params?.wedding;

        try {
            const result = await UpdateWeddingCanva(selectedWeddingCanva?._id, { ...selectedWeddingCanva, canva }, 'CANVA_EDITOR');

            if (result.success) {
                const data = result?.data;
                if (data?.warning && data?.warning?.trim() === 'NEW_CANVA_VERSION_TO_SAVE') {
                    return Alerts.new({ type: 'warning', title: translate("ALERT_ATTENTION_TEXT"), text: translate("NEW_CANVA_VERSION") });
                }

                Alerts.new({ type: 'success', title: translate("SUCCESS"), text: translate("CANVA_UPDATED") });
                this.setState({
                    hasCanvaChanges: false,
                    warningOptionIds: [],
                    warningColor: null
                }, () => {
                    this.getWeddingCanva();
                });
            } else {
                Alerts.new({ type: 'error', title: translate("ERROR"), text: (result?.data && result?.data?.trim() !== '') ? translate(result?.data) : '' });
            }
        } catch (error) {
            console.error(error);
        }
    };

    validateCanvaSubmission = async (canva) => {
        const { translate } = this.props;
        const { selectedWeddingCanva, hasCanvaChanges } = this.state;

        if (hasCanvaChanges) {
            return Alerts.new({
                type: "warning",
                title: translate("PENDING_SAVE_CHANGES"),
                text: translate("SAVE_PENDING_CHANGES")
            });
        }

        const res = await ValidateWeddingCanvaSubmission(selectedWeddingCanva?._id);

        if (!res?.success) return;

        const validationData = res?.data;

        // CHECK 1: Single-select duplicates (blocking — red border)
        if (validationData?.hasDuplicates) {
            const questionNames = validationData.duplicateSelections
                .map(d => d.questionTitle);
            const duplicateOptionIds = validationData.duplicateSelections
                .flatMap(d => d.optionIds);
            this.setState({
                warningOptionIds: duplicateOptionIds,
                warningColor: '#ff0004ff'
            });
            return Alerts.new({
                type: "error",
                title: translate("MATERIAL_SELECTION"),
                text: <span>{translate("CANVA_DUPLICATE_SINGLE_SELECT")}:{questionNames.map((name, i) => <React.Fragment key={i}><br />{name}</React.Fragment>)}</span>
            });
        }

        // CHECK 2: Unmatched options (offer auto-selection — yellow border)
        if (validationData?.hasUnmatched) {
            const unmatchedOptionIds = validationData.unmatchedOptions
                .map(o => o.optionId);
            this.setState({
                warningOptionIds: unmatchedOptionIds,
                warningColor: '#c7ba2a'
            });

            Modal.confirm({
                title: translate("MATERIAL_SELECTION"),
                content: <div>
                    <p>{translate("CANVA_UNMATCHED_OPTIONS_CONFIRM")}</p>
                    <p><strong>{validationData.unmatchedOptions.map((o, i) => <React.Fragment key={i}>{o.questionTitle}: {o.optionName}{i < validationData.unmatchedOptions.length - 1 && <br />}</React.Fragment>)}</strong></p>
                </div>,
                okText: translate("CONFIRM"),
                cancelText: translate("CANCEL"),
                onOk: async () => {
                    const autoRes = await AutoSelectCanvaOptions(selectedWeddingCanva?._id);
                    if (autoRes?.success) {
                        Alerts.new({
                            type: 'success',
                            title: translate("SUCCESS"),
                            text: translate("CANVA_AUTO_SELECT_SUCCESS")
                        });
                        this.setState({
                            warningOptionIds: [],
                            warningColor: null
                        }, () => {
                            this.getWeddingCanva();
                            this.validateCanvaSubmission();
                        });
                    }
                }
            });
            return;
        }

        // All valid — proceed to submit
        Modal.confirm({
            title: translate("CANVA_SUBMISSION"),
            content: <div><p>{translate("CANVA_SUBMISSION_CONFIRM")}</p></div>,
            okText: translate("CONFIRM"),
            cancelText: translate("CANCEL"),
            onOk: () => this.submitFinalCanva()
        });
    };

    submitFinalCanva = async () => {
        const { history, match, translate } = this.props;
        const { selectedWeddingCanva } = this.state;
        const weddingId = match?.params?.wedding;

        let imageBlob = null;
        if (this.canvaEditorRef?.current) {
            imageBlob = await this.canvaEditorRef.current();
        }

        const formData = new FormData();
        if (imageBlob) {
            formData.append("image", imageBlob, "canva.png");
        }

        formData.append("canvaId", selectedWeddingCanva._id);

        const res = await SubmitFinalWeddingCanva(selectedWeddingCanva?._id, formData);
        if (res?.success) {
            Alerts.new({
                type: 'success',
                title: translate("SUCCESS"),
                text: translate("CANVA_SUBMITTED_SUCCESS")
            });
            history.push(`/wedding-canva`);
        } else {
            Alerts.new({
                type: 'error',
                title: translate("ERROR"),
                text: translate("CANVA_SUBMITTED_ERROR")
            });
        }
    };

    approveFinalCanva = async () => {
        const { history, match, translate } = this.props;
        const { selectedWeddingCanva } = this.state;
        const weddingId = match?.params?.wedding;

        const res = await ApproveFinalWeddingCanva(selectedWeddingCanva?._id);
        if (res?.success) {
            Alerts.new({
                type: 'success',
                title: translate("SUCCESS"),
                text: translate("CANVA_APPROVED_SUCCESS")
            });
            history.push(`/wedding-canva`);
        } else {
            Alerts.new({
                type: 'error',
                title: translate("ERROR"),
                text: translate("CANVA_APPROVED_ERROR")
            });
        }
    };

    openCanvaInstructions = () => {
        this.setState({ instructionsModalVisible: true });
    };

    closeCanvaInstructions = () => {
        this.setState({ instructionsModalVisible: false });
    };

    renderCanvaInstructionsModal = () => {
        const { instructionsModalVisible } = this.state;

        return (
            <Modal
                title="Instruções do editor de Canva"
                visible={instructionsModalVisible}
                onCancel={this.closeCanvaInstructions}
                footer={null}
                width={700}
            >
                <p><b>1{')'}</b> Para adicionar objetos/imagens ao Canva tem de selecionar uma <b>"Secção {'>'} Capítulo {'>'} Questão"</b>, presentes no topo da página e posteriormente selecionar uma das opções presentes no menu do lado direito</p>

                <p><b>2{')'}</b> Para escrever algum texto no Canva tem de clicar com o botão do lado direito do rato numa qualquer posição do Canva</p>

                <p><b>3{')'}</b> Se der "double-click" num texto, pode editá-lo</p>

                <p><b>4{')'}</b> Ao clicar com o botão do lado direito do rato num objeto/texto, pode <b>"Enviar para a frente"</b>, <b>"Enviar para trás"</b> ou <b>"Remover"</b></p>

                <p><b>5{')'}</b> No canto inferior esquerdo tem as opções de <b>"Desfazer"</b> e <b>"Refazer"</b> as alterações</p>

                <p><b>6{')'}</b> Entre as opções de gravação pode: "Guardar" as alterações efetuadas no Canva; "Finalizar" este Canva, passando automaticamente para o estado de aprovado</p>
            </Modal>
        );
    };

    openOptionModal = () => {
        this.setState({ optionModalVisible: true });
    };

    closeOptionModal = () => {
        this.setState({ optionModalVisible: false });
    };

    confirmOptionSelection = value => {
        this.setState({ optionModalVisible: false }, () => {
            this.handleOptionChange(value);
        });
    };

    openDrawer = () => this.setState({ drawerVisible: true });
    closeDrawer = () => this.setState({ drawerVisible: false });

    addOptionToCanvas = (optionId, quantity) => {
        const { activeLanguage } = this.props;

        const selectedOptionObj = this.state.selectedQuestionObj.options.find(
            o => String(o._id) === optionId
        );

        const image = selectedOptionObj?.canvaImages?.[0];
        const file = image?.file;
        if (!file) return;

        const newImages = [];
        for (let i = 0; i < quantity; i++) {
            newImages.push({
                id: `${file?._id}_${Date.now()}_${i}`,
                url: `${process.env.REACT_APP_API}/files/${file?._id}`,
                image: image?._id,
                option: selectedOptionObj?._id,
                isAnswered: selectedOptionObj?.isAnswered,
                name: selectedOptionObj?.title,
                date: new Date().toISOString()
            });
        }

        this.setState(prev => ({
            canvaImage: [...(prev.canvaImage || []), ...newImages]
        }));
    };

    togglePanel = () => {
        this.setState(prev => ({ panelCollapsed: !prev.panelCollapsed }));
    };

    openPaletteModal = () => {
        this.setState({
            paletteModalVisible: true,
            tempAnsweredColors: [...this.state.answeredColors]
        });
    };

    closePaletteModal = () => {
        this.setState({ paletteModalVisible: false, tempAnsweredColors: [] });
    };

    savePaletteColors = async () => {
        const { translate } = this.props;
        const { tempAnsweredColors, colorsAnswerId } = this.state;
        const res = await SaveWeddingCanvaColors(colorsAnswerId, { response: tempAnsweredColors });
        if (res?.success) {
            this.setState({
                answeredColors: tempAnsweredColors,
                paletteModalVisible: false,
                tempAnsweredColors: []
            });
            Alerts.new({ type: 'success', title: translate("SUCCESS"), text: translate("CANVA_UPDATED") });
        }
    };

    renderFiltersSection = () => {
        const { translate } = this.props;
        const { sectionsList, selectedSection, chaptersList, selectedChapter, questionsList, selectedQuestion, optionsList, selectedOption } = this.state;

        return <React.Fragment>
            <CanvaFiltersSection>
                <Row gutter={16} style={{ marginBottom: 16 }}>
                    <Col span={6}>
                        <SelectInput
                            label={translate("SECTION")}
                            data={sectionsList}
                            input={{ value: selectedSection, onChange: this.handleSectionChange }}
                            meta={{ valid: true }}
                        />
                    </Col>

                    {chaptersList.length > 0 && (
                        <Col span={6}>
                            <SelectInput
                                label={translate("CHAPTER")}
                                data={chaptersList}
                                input={{ value: selectedChapter, onChange: this.handleChapterChange }}
                                meta={{ valid: true }}
                            />
                        </Col>
                    )}

                    {questionsList.length > 0 && (
                        <Col span={6}>
                            <SelectInput
                                label={translate("QUESTION")}
                                data={questionsList}
                                input={{ value: selectedQuestion, onChange: this.handleQuestionChange }}
                                meta={{ valid: true }}
                            />
                        </Col>
                    )}
                </Row>
            </CanvaFiltersSection>
        </React.Fragment>
    }

    renderColorsSection = () => {
        const { activeLanguage, translate } = this.props;
        const { colorsLoaded, showColors, colorsChapter, colors, answeredColors, colorsQuestion, paletteModalVisible, tempAnsweredColors } = this.state;

        const selectedColors = colors.filter(c => answeredColors.includes(c._id));

        return <React.Fragment>
            <CanvaColorsSubtitle>{colorsChapter?.name[activeLanguage?.code] || ''}</CanvaColorsSubtitle>

            {showColors && (
                <React.Fragment>
                    <CanvaColorsSection isColor={true}>
                        {selectedColors.map((elem, index) => (
                            <CanvaColorsContainer key={index} style={{ display: 'inherit' }}>
                                <WeddingCanvaColorCard
                                    question={colorsQuestion}
                                    record={elem}
                                    input={{
                                        value: answeredColors,
                                        onChange: () => {}
                                    }}
                                />
                            </CanvaColorsContainer>
                        ))}

                        {colorsLoaded && (
                            <CanvaColorsContainer style={{ display: 'flex', alignItems: 'center' }}>
                                <Button
                                    onClick={this.openPaletteModal}
                                    style={{
                                        width: 80,
                                        height: 80,
                                        borderRadius: '50%',
                                        fontSize: 40,
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        padding: 0,
                                        lineHeight: 1,
                                        marginTop: 30
                                    }}
                                >
                                    +
                                </Button>
                            </CanvaColorsContainer>
                        )}
                    </CanvaColorsSection>

                    <Modal
                        title="Palete de Cores"
                        visible={paletteModalVisible}
                        onCancel={this.closePaletteModal}
                        onOk={this.savePaletteColors}
                        okText={translate("SAVE_COLORS")}
                        cancelText={translate("CANCEL")}
                        width={800}
                    >
                        <CanvaColorsSection isColor={true} style={{ flexWrap: 'wrap' }}>
                            {colors.map((elem, index) => (
                                <CanvaColorsContainer key={index} style={{ display: 'inherit' }}>
                                    <WeddingCanvaColorCard
                                        question={colorsQuestion}
                                        record={elem}
                                        input={{
                                            value: tempAnsweredColors,
                                            onChange: (newList) => this.setState({ tempAnsweredColors: newList })
                                        }}
                                    />
                                </CanvaColorsContainer>
                            ))}
                        </CanvaColorsSection>
                    </Modal>
                </React.Fragment>
            )}
        </React.Fragment>
    }

    renderButtonsSection = () => {
        const { translate } = this.props;
        const { colorsLoaded, showColors, panelCollapsed } = this.state;

        return <React.Fragment>
            <div style={{ display: 'flex', gap: '5px', marginBottom: '10px', alignItems: 'center' }}>
                {colorsLoaded && (
                    <BaseButton
                        type="default"
                        icon={showColors ? "up" : "down"}
                        text={showColors ? translate("HIDE_COLORS") : translate("SHOW_COLORS")}
                        onClick={() =>
                            this.setState(prev => ({ showColors: !prev.showColors }))
                        }
                    />
                )}

                <div style={{ display: 'flex', gap: '5px', marginLeft: 'auto' }}>
                    {/* <BaseButton
                        type="primary"
                        icon={"check"}
                        text={translate("FINISH_CANVA")}
                        onClick={this.validateCanvaSubmission}
                    /> */}
                    <BaseButton
                        type="default"
                        icon={panelCollapsed ? "left" : "right"}
                        text={panelCollapsed ? translate("SHOW_OPTIONS") : translate("HIDE_OPTIONS")}
                        onClick={this.togglePanel}
                    />
                </div>
            </div>
        </React.Fragment>;
    }

    renderCanvaWarning = () => {
        const { translate } = this.props;
        return <React.Fragment>
            <div style={{ textAlign: 'left', margin: '10px 0px 10px 0px', fontSize: '14px', width: '80%' }}>{translate("CANVA_PAGE_WARNING_UNAVAILABLE_MATERIALS")}</div>
            <div style={{ textAlign: 'left', margin: '10px 0px 10px 0px', fontSize: '14px', width: '80%' }}>{translate("CANVA_LD_OBJECTS_WARNING")}</div>
        </React.Fragment>
    }

    renderCanvaEditor = () => {
        const { translate, activeLanguage } = this.props;
        const { optionsList, selectedWeddingCanva, canvaImage, panelCollapsed, warningOptionIds, warningColor } = this.state;

        return <React.Fragment>
            <div style={{ display: "flex", width: "100%", height: "calc(100vh - 120px)" }}>
                <div style={{ flex: panelCollapsed ? 1 : 0.8, minWidth: 0 }}>
                    <CanvaEditor
                        ref={this.canvaEditorRef}
                        onExportImage={this.canvaEditorRef}
                        selectedImages={canvaImage}
                        existingObjects={selectedWeddingCanva?.canva?.objects || []}
                        existingLines={selectedWeddingCanva?.canva?.lines || []}
                        backgroundImage={selectedWeddingCanva}
                        fullWidth={panelCollapsed}
                        onSave={this.saveCanvaEditor}
                        onApprove={this.validateCanvaSubmission}
                        onChange={() => this.setState({ hasCanvaChanges: true })}
                        onSaved={() => this.setState({ hasCanvaChanges: false })}
                        onOpenInstructions={this.openCanvaInstructions}
                        warningOptionIds={warningOptionIds}
                        warningColor={warningColor}
                        translate={translate}
                        activeLanguage={activeLanguage?.code}
                    />
                </div>

                {!panelCollapsed && (
                    <div style={{ flex: 0.2, minWidth: 200 }}>
                        <ImageOptionPanel
                            options={optionsList}
                            onAddToCanvas={this.addOptionToCanvas}
                        />
                    </div>
                )}
            </div>
        </React.Fragment>
    }

    render() {
        const { translate } = this.props;
        const { loading, redirect, selectedWeddingCanva, hasCanvaChanges } = this.state;

        if (redirect) return <Redirect to="/wedding-canva" />;

        if (loading) return <div>Carregando...</div>;

        return <React.Fragment>
            <XpertGoLeavePageBlocker
                when={hasCanvaChanges}
                message={translate("CANVA_UNSAVED_EXIT_WARNING")}
                checkedChanges={false}
            />

            <div style={{ padding: 20 }}>
                <SectionTitle>{translate("CANVA_EDITOR")} - {selectedWeddingCanva?.name || ''}</SectionTitle>
                {this.renderFiltersSection()}
                {this.renderColorsSection()}
                {this.renderButtonsSection()}
                {this.renderCanvaWarning()}
                {this.renderCanvaEditor()}
                {/* {this.renderCanvaInstructionsModal()} */}
            </div>
        </React.Fragment>;
    }
}

export default withRouter(
    withLocalize(CanvaEditorPage)
);
